import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { useEffect, useState } from 'react';
import './style.less';

export interface SwitchProps {
  onPreChange?: (value: boolean) => Promise<void>;
  onChange?: (value: boolean) => void | Promise<void>;
  value?: boolean;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

export const Switch = (props: SwitchProps) => {
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(props.value || false);
  }, [props.value]);

  const toogle = (nextStatus: boolean) => {
    const { onChange, disabled } = props;
    if (disabled) {
      return;
    }
    setLoading(true);
    const result = onChange?.(nextStatus);
    if (result && result.then) {
      result
        .then(() => {
          setLoading(false);
          setChecked(nextStatus);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
      setChecked(nextStatus);
    }
  };

  const handleClick = hooks.useCallbackRef(() => {
    if (props.onPreChange) {
      void props.onPreChange(!checked).then(() => {
        toogle(!checked);
      });
    } else {
      toogle(!checked);
    }
  });

  const className = classNames(
    'v-switch',
    {
      'v-switch-disabled': props.disabled,
      'v-switch-loading': loading || props.loading,
      'v-switch-on': checked,
    },
    props.className,
  );

  return (
    <div className={className} onClick={handleClick}>
      <i className="before"></i>
      <div className="after">{loading ? <div className="i-spinner"></div> : null}</div>
    </div>
  );
};
